


import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import requestService from "@/service/requestService";
import Number from "@/shared/filters/Number";
import { Utils } from "@/service/util";
import { CouponData } from "@/model/Coupon";
import { Getter, Action } from "vuex-class";
import ConfirmDialog from "@/components/common/ConfirmDialog.vue";
import { UserService } from "@/service/UserService";
import UserFooter from "@/components/UserFooter.vue";
import { MESSAGE } from "@/model/Message";
import TopBarTitle from "@/components/common/TopBarTitle.vue";
import InputNumber from "@/components/common/input/InputNumber.vue";
import CouponPage from "@/page/user/CouponPage.vue";
@Component({
  filters: {
    Number
  },
  components: {
    ConfirmDialog,
    UserFooter,
    TopBarTitle,
    InputNumber
  }
})
export default class CouponPageQuick extends CouponPage {
  isModeModal: boolean = false;
  isModeQuick: boolean = true;
  excludingFlg: boolean = false; // これで必要な設定になってる
  excludingTex: string = "税込"; // これで必要な設定になってる

  public utils: Utils = new Utils();

  onConfirm(isConfirm: number) {
    if (this.couponData) {
      if (this.couponData.coupon && this.couponData.coupon.items) {
        this.couponData.coupon.subTotalZk = this.subTotalZk;
        this.couponData.coupon.subTotalZn = this.subTotalZn;
      }
      this.setCoupon(this.couponData);
      let isConfirmCopied: any = isConfirm;
      if (isConfirm == 0) {
        isConfirmCopied = this.couponData.isConfirm;
      }
      if (
        this.couponDataForSave.coupon &&
        this.couponDataForSave.proposal &&
        this.couponDataForSave.tokuten
      ) {
        this.$set(this, "updating", true);
        this.reqService
          .saveCoupon({ // sendSocket:ソケット仮11
            coupons: this.couponDataForSave.coupon.items || [],
            proposals: this.couponDataForSave.proposal.items || [],
            tokutens: this.couponDataForSave.tokuten.items || [],
            sknUketsukeUserJouhou: {
              isConfirmCoupon: isConfirmCopied
            },
            sknUketsukeExtendsId: this.uketsukeExtendsId
          })
          .then(
            (res: any) => {
              this.$set(this, "updating", false);
              if (isConfirm == 1) {
                this.$router.push({ name: "quickseibilist" });
                this.confirm(isConfirmCopied);
                this.$emit("onUserConfirm");
              }
            },
            (error: any) => {
              this.$set(this, "updating", false);
              this.$notify.error({
                title: "エラー",
                message: MESSAGE.SystemError
              });
            }
          );
      } else {
        this.confirm(isConfirmCopied);
        this.$emit("onUserConfirm");
      }
    } else {
      if (isConfirm == 1) {
        this.$router.push({ name: "quickseibilist" });
      }
    }
  }
  
  onChangeCoupon(option?: any) {
    this.onCheckChange(option);
  }

}
